module.exports = __webpack_public_path__ + "static/media/jak-to-wszystko-sie-zaczelo.79c26065.jpg";